import { useQuery } from '@tanstack/react-query';

import { fetchChannels } from '../services/staylive';

import type { StayLiveChannel } from '../services/staylive';

export const useStayLiveChannels = () => {
  return useQuery({
    queryKey: ['staylive'],
    queryFn: fetchChannels,
    initialData: [] as StayLiveChannel[],
  });
};
